"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameEvent = void 0;
const Utils_1 = require("../Utils/Utils");
class GameEvent {
    constructor() {
        this.listeners = new Set();
        this.prevArgs = null;
    }
    emit(...args) {
        const list = Utils_1.setItems(this.listeners);
        for (const listener of list) {
            listener(() => this.listeners.delete(listener), ...args);
        }
        this.prevArgs = args;
    }
    add(listener) {
        this.listeners.add(listener);
    }
    remove(listener) {
        return this.listeners.delete(listener);
    }
    clear() {
        this.listeners.clear();
    }
}
exports.GameEvent = GameEvent;
//# sourceMappingURL=GameEvent.js.map